import { Card } from "../Card";
import { Skeleton } from "../Skeleton";
import { RegionCargando } from "./RegionCargando";

export interface ListaTarjetasSkeletonProps {
  tarjetas?: number;
  /** false cuando ya lo anuncia un contenedor padre (p. ej. `TablaSkeleton movil`). */
  anunciar?: boolean;
}

/** Variante móvil de las tablas · tarjetas apiladas (folio + estado, 2 líneas, monto). */
export function ListaTarjetasSkeleton({ tarjetas = 5, anunciar = true }: ListaTarjetasSkeletonProps) {
  const contenido = Array.from({ length: tarjetas }, (_, i) => (
    <Card key={i} padding="md" aria-hidden="true">
      <div className="flex items-center justify-between gap-3">
        <Skeleton height={14} width="40%" />
        <Skeleton height={20} width={84} className="rounded-full" />
      </div>
      <Skeleton height={12} width="85%" className="mt-3" />
      <Skeleton height={12} width="60%" className="mt-2" />
      <div className="mt-3 flex justify-end">
        <Skeleton height={16} width={96} />
      </div>
    </Card>
  ));
  return anunciar ? (
    <RegionCargando className="flex flex-col gap-2">{contenido}</RegionCargando>
  ) : (
    <div className="flex flex-col gap-2">{contenido}</div>
  );
}
